import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./redux/store";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Modal from "react-modal";
import React from "react";
import App from "./App";
import "./tailwind.css";

Modal.setAppElement("#root");

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
